module.exports = __webpack_public_path__ + "img/sofitel_bg.6d81c123.png";